import * as idbKeyVal from 'idb-keyval';

const defaultOpts = { maxAge: Infinity, version: 0, lib: idbKeyVal };
const getOpts = (passedOptions) => Object.assign({}, defaultOpts, passedOptions);

export const keyValLib = idbKeyVal;

// IndexedDB lagrer verdier via strukturert kloning. Tidligere wrappa vi data
// med JSON.stringify før set og JSON.parse etter get, noe som var dobbel
// serialisering og blokkerte hovedtråden synkront for store payloads.
// Vi lagrer nå objektet direkte og lar idb-keyval/IndexedDB håndtere kloning.
// Lese-stien aksepterer fortsatt den gamle string-formen så eksisterende
// caches ikke invalideres på første lasting etter deploy.
export const get = (key, opts, store) => {
  const { maxAge, version, lib } = getOpts(opts);
  return lib
    .get(key, store)
    .then((raw) => {
      if (raw === undefined || raw === null) return null;
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!parsed || typeof parsed !== 'object') return null;
      const age = Date.now() - parsed.time;
      if (age > maxAge || version !== parsed.version) {
        lib.del(key, store);
        return null;
      }
      return parsed.data;
    })
    .catch(() => null);
};

export const set = (key, data, spec, store) => {
  const { lib, version } = getOpts(spec);
  return lib.set(key, { version, time: Date.now(), data }, store).catch(() => null);
};

export const getAll = (spec, store) => {
  const opts = getOpts(spec);
  let keys;
  return opts.lib
    .keys(store)
    .then((retrievedKeys) => {
      keys = retrievedKeys;
      return Promise.all(keys.map((key) => get(key, opts, store)));
    })
    .then((data) =>
      data.reduce((acc, bundleData, index) => {
        if (bundleData) {
          acc[keys[index]] = bundleData;
        }
        return acc;
      }, {}),
    )
    .catch(() => {});
};

export const getConfiguredCache = (spec) => {
  const opts = getOpts(spec);
  let store;
  if (opts.name) {
    store = idbKeyVal.createStore(opts.name, opts.name);
  }
  return {
    get: (key) => get(key, opts, store),
    set: (key, val) => set(key, val, opts, store),
    getAll: () => getAll(opts, store),
    del: (key) => opts.lib.del(key, store),
    clear: () => opts.lib.clear(store),
    keys: () => opts.lib.keys(store),
  };
};
